import { KotlinLoggingConfiguration_getInstance2pq6qv2bwynbv as KotlinLoggingConfiguration_getInstance } from './KotlinLoggingConfiguration.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FormattingAppenderClass;
function FormattingAppender() {
  if (FormattingAppenderClass === VOID) {
    class $ {
      h2g(loggingEvent) {
        // Inline function 'kotlin.let' call
        var it = KotlinLoggingConfiguration_getInstance().j2g_1.l2g(loggingEvent);
        this.g2g(loggingEvent, it);
      }
    }
    initMetadataForClass($, 'FormattingAppender');
    FormattingAppenderClass = $;
  }
  return FormattingAppenderClass;
}
//region block: exports
export {
  FormattingAppender as FormattingAppender1iqfktuucnzpr,
};
//endregion

//# sourceMappingURL=Appender.mjs.map
